var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-circular',{attrs:{"size":_vm.size,"width":_vm.width,"value":_vm.porcentaje,"rotate":_vm.rotate,"color":_vm.color}},[_vm._v("\n    "+_vm._s(_vm.porcent)+"%\n")])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb20faee","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/PresupProgreso.vue
// module id = rZNT
// module chunks = 0